<template>
    <BaseForm
        class="order-gift-step-one"
        @submit="onSubmit"
    >
        <template #title>
            <slot name="title" />
        </template>

        <template #content>
            <slot name="description" />

            <BaseFormField
                :required="true"
            >
                <template #label>
                    Aantal Giftcards
                </template>

                <BaseSelect
                    v-model="amountField"
                    placeholder="Kies aantal"
                    :options="giftAmountOptions"
                    :clearable="false"
                    required
                >
                    <template #after>
                        <BaseIcon icon="dropdown" />
                    </template>
                </BaseSelect>
            </BaseFormField>

            <FormFieldColumns
                data-columns-mobile="2"
                data-columns-desktop="2"
            >
                <FieldValidator
                    v-slot="{ field, meta, errors, handleReset }"
                    name="firstName"
                >
                    <BaseFormField
                        :required="true"
                        :errors="errors"
                    >
                        <template #label>Voornaam</template>

                        <BaseInput
                            v-bind="field"
                            :validator="meta"
                            @clear="handleReset"
                        />
                    </BaseFormField>
                </FieldValidator>

                <FieldValidator
                    v-slot="{ field, meta, errors, handleReset }"
                    name="lastName"
                >
                    <BaseFormField
                        :required="true"
                        :errors="errors"
                    >
                        <template #label>Achternaam</template>

                        <BaseInput
                            v-bind="field"
                            :validator="meta"
                            @clear="handleReset"
                        />
                    </BaseFormField>
                </FieldValidator>
            </FormFieldColumns>

            <FieldValidator
                v-slot="{ field, meta, errors, handleReset }"
                name="email"
            >
                <BaseFormField
                    :required="true"
                    :errors="errors"
                >
                    <template #label>Email</template>

                    <BaseInput
                        v-bind="field"
                        :validator="meta"
                        type="email"
                        @clear="handleReset"
                    />
                </BaseFormField>
            </FieldValidator>
        </template>

        <template #actions>
            <BaseButton class="button--secondary">
                Volgende stap
            </BaseButton>
        </template>
    </BaseForm>
</template>

<script setup lang="ts">
import { useForm, Field as FieldValidator } from 'vee-validate';

const props = defineProps<{
    giftCardPrice: number;
    giftCardAmountOptions: Array<{
        label: string | undefined;
        amount: number | undefined;
    }>;
}>();

const emit = defineEmits(['submit']);

const { user } = storeToRefs(useUserStore());


const giftAmountOptions = computed(() => {
    return props.giftCardAmountOptions?.map(({ label, amount }) => ({ label: label ?? '1', value: amount ?? 1 }));
    // return [...Array(5).keys()].map((x) => {
    //     return {
    //         label: `${x + 1} gift card${x > 0 ? 's' : ''} (€${props.giftCardPrice * (x + 1)})`,
    //         value: x + 1
    //     };
    // });
});

const { handleSubmit, defineField, setFieldError } = useForm({
    validationSchema: {
        amount: 'required',
        email: 'required|email',
        firstName: 'required',
        lastName: 'required',
    },
    initialValues: {
        amount: giftAmountOptions.value?.[0]?.value ?? 1,
        email: user.value?.email,
        firstName: user.value?.first_name,
        lastName: user.value?.last_name
    }
});

const [amountField] = defineField('amount');

const onSubmit = handleSubmit(async(formData) => {
    const { error } = await useFetchLaravel<null, { message?: string }>('/v2.0/email-confirmation/send', {
        method: 'POST',
        data: {
            email: formData.email,
        }
    });

    if (error.value?.data?.message === 'ERROR_ACTIVE_MEMBER_LOGIN') {
        setFieldError('email', 'Er bestaat al een actief account met dit email adres, log eerst in en probeer het opnieuw.');
    }

    if (!error.value && formData.email) {
        useSignUpStore().setEmail(formData.email);

        emit('submit', formData);
    }
});
</script>

<style lang="less" src="./FormOrderGiftStepOne.less">
</style>
